import { useCallback, useState } from 'react';

const KEY = 'activistarc.portal.nav-folded';

function read(): boolean {
  try {
    return localStorage.getItem(KEY) === 'true';
  } catch {
    // A private window or blocked site data: simply not folded.
    return false;
  }
}

function write(folded: boolean): void {
  try {
    if (folded) localStorage.setItem(KEY, 'true');
    else localStorage.removeItem(KEY);
  } catch {
    // Nothing to do. The choice then lasts until the page is reloaded.
  }
}

/**
 * Whether the left navigation is folded to icons on a desktop.
 *
 * Remembered in this browser, as a per-person convenience: it is how somebody
 * likes their screen, not anything the portal needs to know. localStorage
 * rather than sessionStorage, so it outlives the tab.
 */
export function useNavFolded(): [boolean, () => void] {
  const [folded, setFolded] = useState(read);

  const toggle = useCallback(() => {
    setFolded((current) => {
      write(!current);
      return !current;
    });
  }, []);

  return [folded, toggle];
}
